<div class="footer">
  <div class="container">
    <div class="row">
      <div class="col center">
        <!-- <img src="" alt="">&nbsp; -->
        <span class="f-white">{{i18n.SIGNATURE.AMBIENTE_SEGURO}}</span>
      </div>
    </div>
  </div>
</div>